import fieldMixin from '@maison/mixins/fieldMixin';
import textFieldMixin from '@phoenix/mixins/textFieldMixin';

export default {
  mixins: [fieldMixin, textFieldMixin],

  props: {
    forceLtr: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    customFieldClasses() {
      return ['field--text', { 'force-ltr': this.forceLtr || this.field.forceDirection === 'ltr' }, this.fieldClasses];
    },

    htmlType() {
      return this.field.type === 'phone' ? 'tel' : this.field.type;
    },

    inputmode() {
      if (this.field.inputmode) {
        return this.field.inputmode;
      }

      if (this.field.type === 'email') {
        return 'email';
      }

      if (this.field.type === 'phone') {
        return 'tel';
      }

      if (this.field.type === 'number') {
        return 'numeric';
      }

      return 'text';
    },

    pattern() {
      if (this.field.pattern || this.$attrs?.pattern) {
        return this.field.pattern || this.$attrs.pattern;
      }

      if (this.field.name === 'zip') {
        return '^[A-Z0-9]+(?:[-\\s]?[A-Z0-9]+)*$';
      }

      return null;
    },
  },
};
